import { useUser } from '@clerk/clerk-react'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

/**
 * Keeps the Sentry user context in sync with the Clerk session.
 *
 * When a user is signed in, their id (and email) is attached to every Sentry
 * event so issues can be traced back to an account. On sign-out the user is
 * cleared. Must be called from a component rendered inside <ClerkProvider>.
 */
export const useSentryUser = () => {
  const { user, isSignedIn } = useUser()

  useEffect(() => {
    if (isSignedIn && user)
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
      })
    else Sentry.setUser(null)
  }, [isSignedIn, user])
}
